const sep = "___"


export function convertToGraphologyFormat(data) {
    const graphologyGraph = {
        attributes: {},
        nodes: [],
        edges: []
    };

    // Convert nodes
    data.nodes.forEach(node => {
        graphologyGraph.nodes.push({
            key: node.id,
            attributes: {
                name: node.name,
                statuses: node.statuses,
                affiliations: node.affiliations,
                primary_status: node.primary_status,
                group: node.group
            }
        });
    });

    // Convert links
    data.links.forEach(link => {
        const edgeKey = String(link.source).concat(sep, String(link.target), sep, link.edge_ids.join(sep));
        // const edgeKey = link.source.concat(sep,link.target,sep,link.edge_ids.join('-'),sep,link.source); // Creating a unique key
        graphologyGraph.edges.push({
            key: edgeKey,
            source: link.source,
            target: link.target,
            attributes: {
                value: link.value,
                dateInstances: link.dateInstances
            }
        });
    });

    return graphologyGraph;
}

export function convertFromGraphologyFormat(graphologyData) {
    const originalFormat = {
        nodes: [],
        links: []
    };

    // Convert nodes back
    graphologyData.nodes.forEach(node => {
        let originalNode = {
            id: node.key,
            // ... other specific keys if necessary
        };

        // Dynamically add all attributes
        Object.keys(node.attributes).forEach(attrKey => {
            originalNode[attrKey] = node.attributes[attrKey];
        });

        originalFormat.nodes.push(originalNode);
    });

    // Convert edges back
    graphologyData.edges.forEach(edge => {
        const [source, target, ...restEdgeIds] = edge.key.split(sep);
        const originalLink = {
            source: source,
            target: target,
            edge_ids: restEdgeIds,
            // ... other specific keys if necessary
        };

        // Dynamically add all attributes
        Object.keys(edge.attributes).forEach(attrKey => {
            originalLink[attrKey] = edge.attributes[attrKey];
        });

        originalFormat.links.push(originalLink);
    });

    return originalFormat;
}

export function convertFromGraphologyFormat2(graphologyData) {
    const originalFormat = {
        nodes: [],
        links: []
    };

    // Convert nodes back
    graphologyData.forEachNode((nodeKey, nodeAttributes) => {
        let originalNode = {
            id: nodeKey,
            // ... other specific keys if necessary
        };

        // Dynamically add all attributes from nodeAttributes
        Object.entries(nodeAttributes).forEach(([attrKey, attrValue]) => {
            originalNode[attrKey] = attrValue;
        });

        originalFormat.nodes.push(originalNode);
    });

    // Convert edges back
    graphologyData.forEachEdge((edgeKey, edgeAttributes, source, target, sourceAttributes, targetAttributes, undirected, edgeData) => {
        const originalLink = {
            source: source,
            target: target,
            // ... other specific keys if necessary
        };

        // Dynamically add all attributes from edgeAttributes
        Object.entries(edgeAttributes).forEach(([attrKey, attrValue]) => {
            originalLink[attrKey] = attrValue;
        });

        originalFormat.links.push(originalLink);
    });

    return originalFormat;
}

export function findMinMaxAttribute(graph, attributeName) {
    let min = Infinity;
    let max = -Infinity;

    graph.forEachNode((node, attributes) => {
        const attr = attributes[attributeName];
        if (attr !== undefined) {
            min = Math.min(min, attr);
            max = Math.max(max, attr);
        }
    });

    // After iterating through all nodes
    console.log(`Minimum : ${min}`);
    console.log(`Maximum : ${max}`);


    return { min, max };
}

export function findMinMaxDates(links) {
    // Example usage
    // const { minDate, maxDate } = findMinMaxDates(yourLinksArray);
    // console.log("Min Date:", minDate);
    // console.log("Max Date:", maxDate);

    let minDate = new Date('9999-12-31'); // Initialize to a very late date
    let maxDate = new Date('0000-01-01'); // Initialize to a very early date
    let thresholdDate = new Date('1990-01-01'); // Initialize to a very early date

    links.forEach(link => {
        link.dateInstances.forEach(instance => {
            let startDate = new Date(instance.start);
            let endDate = new Date(instance.end);

            if (startDate < minDate && thresholdDate < startDate) minDate = startDate;
            if (endDate > maxDate) maxDate = endDate;
        });
    });

    return { minDate, maxDate };
}

export function findMaxCentralities(nodes) {
    // Example usage

    let maxBtw = 0
    let maxDgr = 0

    nodes.forEach(node => {
        let btw = node.nodeBtwCentrality ;
        let dgr = node.nodeDgrCentrality;

        if (btw > maxBtw) maxBtw = btw;
        if (dgr > maxDgr) maxDgr = dgr;

    });

    return { maxBtw, maxDgr };
}

